module.exports = __webpack_public_path__ + "img/yashav_yes.56941fe0.png";